export interface VacancyUploadResultModel {
  document_id: string | null;
}
